import React from 'react';
import styled from 'styled-components';
import { inputStyle } from './Input';

const StyledInput = styled.input`
  ${inputStyle}
  height: 26px;
  width: 75px;
`;

export const TimeInputHours = ({
  value,
  onChange,
  index,
  hoursMonday,
  setHoursMonday,
  day,
  ...rest
}) => {
  const handleChange = (e) => {
    if (onChange) {
      onChange({ e, day, index });
    }
  };

  return <StyledInput value={value} type="time" onChange={handleChange} {...rest} />;
};
